import * as React from 'react';

import {
  Option,
  OptionLabel,
  OptionWrapper
} from 'components/MainLayout/styled';

export function SupportOption({
  href,
  icon,
  label
}: {
  href: string;
  icon: React.ReactNode;
  label: string;
}): JSX.Element {
  return (
    <Option>
      <a href={href} target="_blank" rel="noopener noreferrer">
        <OptionWrapper>
          {icon}
          <OptionLabel>{label}</OptionLabel>
        </OptionWrapper>
      </a>
    </Option>
  );
}
